// extracted by mini-css-extract-plugin
export default {"grid":"SingleTypeProduct_grid__eaHj9"};